import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';

const CLPackText = ({ lensesPerBox  })=>{
    const { getFormattedLabel  } = useIntl();
    const label = getFormattedLabel('products.facets.boxQuantity.item', {
        labelData: {
            lensesPerBox
        }
    });
    return /*#__PURE__*/ React.createElement(React.Fragment, null, label);
};

export { CLPackText };
//# sourceMappingURL=CLPackText.js.map
